module.exports = __webpack_public_path__ + "img/image_body-point_03_03.d0514eb2.svg";